import styled, { css } from 'styled-components'

import { Section as RootSection } from '@/components/business/market-shop/section'

export const Section = styled(RootSection)(
  () => css`
    // NOTE: using id selector to reuse component from lib but style it as needed in design
    #custom-tip-amount {
      height: 4.4rem;
    }
  `,
)

export const TipOptions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)

export const TipOption = styled.button<{ $active: boolean }>(
  ({ theme, $active }) => css`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: fit-content;
    cursor: pointer;
    overflow: initial;
    padding: calc(${theme.space['10']} - ${theme.border.size['1']})
      calc(${theme.space['16']} - ${theme.border.size['1']});
    margin: 0;
    border-radius: ${theme.border.radius['4']};
    border: ${theme.border.size['1']} solid ${theme.colors.gray600};
    user-select: none;
    background: ${theme.colors.gray100};
    outline: none;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2rem;
    color: ${theme.colors.black600};
    flex-basis: 7.8rem;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${theme.border.size['1']};
    }

    &:disabled {
      cursor: not-allowed;
    }

    ${
      $active &&
      css`
      color: ${theme.colors.white};
      background: ${theme.colors.marketShopBrand800};
      border-color: ${theme.colors.marketShopBrand800};
    `
    }
  `,
)

export const CustomTip = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['4']};
  `,
)
